import { Image } from '@app/components'
import React, { CSSProperties } from 'react'

export const HexIcon = ({ style }: { style?: CSSProperties }) => {
  const size = Number.parseInt(String(style?.height ?? style?.width ?? 24), 10) || 24
  return (
    <Image
      preview={false}
      src="../images/HEXagon.png"
      width={size}
      height={size}
      style={{
        objectFit: 'contain',
        ...style,
        width: size,
        height: size,
        display: style?.display ?? 'block',
      }}
    />
  )
}
